'use-client';
import * as React from 'react';
import type {
  IDropDownMenuProps,
  IDropDownMenuImperativeActions,
} from '../../../DropDownMenu.types';
import MenuButton from '../../../../MenuButton/viewer/skinComps/PointerMenuButtonHorizontalMenuAdaptationSkin/PointerMenuButtonHorizontalMenuAdaptationSkin';
import PointerMenuButton from './PointerMenuButton';
import styles from './PointerMenuButtonHorizontalMenuAdaptationSkin.scss';

const PointerMenuButtonHorizontalMenuAdaptationSkin: React.ForwardRefRenderFunction<
  IDropDownMenuImperativeActions,
  IDropDownMenuProps
> = (props, ref) => {
  return (
    <PointerMenuButton
      {...props}
      ref={ref}
      styles={styles}
      Button={MenuButton}
    />
  );
};

export default React.forwardRef(PointerMenuButtonHorizontalMenuAdaptationSkin);
